import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LockOutlined,
} from "@ant-design/icons";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Typography,
} from "antd";
import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Bg from "../../assets/images/avatars/dash-bg.png";
import Logo from "../../assets/images/logo_stroke_gold.png";
import { apiConfig } from "../../pages/security/security.config";
import cnt from "../../services/definedConstant";
import { BOM } from "../../services/definedMethod";
import BuildPasswordErrorMessage from "../security/BuildPasswordErrorMessage";
import { encryptPayload } from "./EncryptAuth";

const { Title, Text } = Typography;

const PasswordResetForm = ({ userData, onPasswordReset }) => {
  const { session } = userData;
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (values) => {
    setIsLoading(true);
    const encryptedPassword = encryptPayload(values.newPassword);
    const encryptedRepeatPassword = encryptPayload(values.confirmPassword);
    // const params = { command: "resetPassword" };
    const body = {
      password: encryptedPassword,
      repeatPassword: encryptedRepeatPassword,
      method: "PUT",
      session,
      // params,
    };

    BOM.FetchReqAction(
      body,
      `${apiConfig.Users}/${userData.userId}`,
      (err, res) => {
        if (err) {
          setIsLoading(false);
          Modal.error({
            title: "Password Update Failed",
            content: BuildPasswordErrorMessage(err),
            width: 600,
            centered: false,
            style: { top: 400 },
            okButtonProps: {
              style: {
                backgroundColor: "var(--of-purple)",
              },
            },
          });
        } else {
          setIsLoading(false);
          showSuccessModalWithCountdown();
        }
      }
    );
  };

  const showSuccessModalWithCountdown = () => {
    BOM.AlertMsg(cnt.SUCCESS, "Password updated successfully!");
    setTimeout(() => {
      navigate("/sign-in");
    }, 1500);
  };

  const validateConfirmPassword = (_, value) => {
    if (value && value !== form.getFieldValue("newPassword")) {
      return Promise.reject(new Error("Passwords do not match"));
    }
    return Promise.resolve();
  };

  return (
    <>
      <img className="auth-bg" src={Bg} />
      <div className="login-container">
        <Card className="login-card">
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            {/* Header */}
            <div style={{ textAlign: "center" }}>
              <Title
                level={2}
                style={{ color: "#BA24D5", marginBottom: "8px" }}
              >
                Reset Your Password
              </Title>
            </div>

            {/* Alert */}
            <Alert
              message="Password Reset Required"
              description="For security reasons, you must reset your password before accessing your account."
              type="warning"
              showIcon
              style={{ borderRadius: "8px" }}
            />

            {/* Form */}
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              autoComplete="off"
              size="large"
            >
              <Form.Item
                label="New Password"
                name="newPassword"
                rules={BOM.fieldRules("strong-password", true)}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Enter your new password"
                  iconRender={(visible) =>
                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                  }
                  style={{ borderRadius: "8px" }}
                />
              </Form.Item>

              <Form.Item
                label="Confirm New Password"
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: "Please confirm your new password!",
                  },
                  { validator: validateConfirmPassword },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Confirm your new password"
                  iconRender={(visible) =>
                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                  }
                  style={{ borderRadius: "8px" }}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  style={{
                    width: "100%",
                    height: "48px",
                    backgroundColor: "#BA24D5",
                    borderColor: "#BA24D5",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  {isLoading ? "Resetting Password..." : "Reset Password"}
                </Button>
              </Form.Item>
            </Form>

            {/* Footer */}
            <Row>
              <Col span={24}>
                <Footer />
              </Col>
            </Row>
          </Space>
        </Card>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetForm);

const Footer = () => {
  return (
    <div style={{ marginLeft: 100, marginTop: 10 }}>
      Powered by &nbsp;
      <img src={Logo} style={{ margin: 0, padding: 0, width: 20 }} />
      <a
        style={{ textDecoration: "none", color: "#000" }}
        href="https://openfactorgroup.com/"
        target="_blank"
      >
        <strong>penfactor</strong>
      </a>
    </div>
  );
};
